import { render } from "./1TugasPokok.vue?vue&type=template&id=eb4f3bd8"
import script from "./1TugasPokok.vue?vue&type=script&lang=js"
export * from "./1TugasPokok.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__